export function apiErrorParser(errorData) {
    var _a, _b, _c, _d;
    if (!errorData) {
        return;
    }
    const message = errorData.message;
    const apiErrorDetails = {
        code: (_b = (_a = errorData.details) === null || _a === void 0 ? void 0 : _a.applicationError) === null || _b === void 0 ? void 0 : _b.code,
        description: (_d = (_c = errorData.details) === null || _c === void 0 ? void 0 : _c.applicationError) === null || _d === void 0 ? void 0 : _d.description,
        message,
        requestId: parseRequestId(message),
    };
    return apiErrorDetails;
}
const requestIdStringSeparator = 'reference:';
function parseRequestId(message) {
    var _a, _b;
    if (typeof message !== 'string') {
        return;
    }
    const messageString = `${message}`;
    if (!messageString.includes(requestIdStringSeparator)) {
        return;
    }
    return (((_b = (_a = messageString
        .split(requestIdStringSeparator)
        .pop()) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.replace(')', '')) || undefined);
}
//# sourceMappingURL=apiErrorParser.js.map